/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import Tabla from '@infotrack/presentacion-componentes/tabla';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { ITablaFamiliasVistaProps } from '../interfaces';
import { acciones, columnas, opciones } from './constantes';

const VistaFamilias: React.FunctionComponent<ITablaFamiliasVistaProps & InjectedIntlProps> = ({
    familiass,
    cargarFamilias,
    confirmarEliminacion,
    intl,
    manejarFormulario,
}) => (
    <div>
        <Tabla
            columns={columnas(intl.formatMessage)}
            data={familiass}
            actions={acciones(manejarFormulario, cargarFamilias, intl.formatMessage, confirmarEliminacion)}
            options={opciones}
        />
    </div>
);

export default injectIntl(VistaFamilias);
